function createScript (key, cb) {
  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=${cb}`
  script.async = true
  script.defer = true
  let firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(script, firstScriptTag)
}

const state = {
  loading: false,
  loaded: false
}

export const theme = [
  {
    'featureType': 'water',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#e9e9e9'
      },
      {
        'lightness': 17
      }
    ]
  },
  {
    'featureType': 'landscape',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5'
      },
      {
        'lightness': 20
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#ffffff'
      },
      {
        'lightness': 17
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#ffffff'
      },
      {
        'lightness': 29
      },
      {
        'weight': 0.2
      }
    ]
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff'
      },
      {
        'lightness': 18
      }
    ]
  },
  {
    'featureType': 'road.local',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff'
      },
      {
        'lightness': 16
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5'
      },
      {
        'lightness': 21
      }
    ]
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#dedede'
      },
      {
        'lightness': 21
      }
    ]
  },
  {
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'visibility': 'on'
      },
      {
        'color': '#ffffff'
      },
      {
        'lightness': 16
      }
    ]
  },
  {
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'saturation': 36
      },
      {
        'color': '#333333'
      },
      {
        'lightness': 40
      }
    ]
  },
  {
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f2f2f2'
      },
      {
        'lightness': 19
      }
    ]
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#fefefe'
      },
      {
        'lightness': 20
      }
    ]
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#fefefe'
      },
      {
        'lightness': 17
      },
      {
        'weight': 1.2
      }
    ]
  }
]

const mapOptions = () => ({
  styles: theme,
  disableDefaultUI: true
})

const markerOptions = () => ({
  icon: {
    path: 'M8.5,4.5c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S8.5,2.3,8.5,4.5z',
    fillColor: '#EE028C',
    fillOpacity: 1,
    strokeColor: 'white'
  }
})

export class GoogleMaps {
  constructor ({key, cbFn}) {
    const callbackFn = cbFn || '_googleMapsCallBackFN'
    this.resolves = []
    // If neither window.google or window.googe.maps AND this isn't already loading, trying to load
    if ((!window.google || !window.google.maps) && !state.loading && !state.loaded) {
      createScript(key, callbackFn)
      state.loading = true
    }

    window[callbackFn] = () => {
      this.onInit()
    }
  }

  onInit () {
    state.loaded = true
    this.resolves.forEach(resolve => resolve(this.result()))
  }

  getInstance () {
    return new Promise((resolve, reject) => {
      if (!window.google || !window.google.maps) {
        this.resolves.push(resolve)
        return
      }

      resolve(this.result())
    })
  }

  getDefaultMapOptions () {
    return mapOptions()
  }

  getDefaultMarkerOptions () {
    return markerOptions()
  }

  result () {
    return window.google.maps
  }
}

export class LatLng {
  constructor (lat, lng) {
    this.lat = Number(lat)
    this.lng = Number(lng)
  }

  toJSON () {
    return {lat: this.lat, lng: this.lng}
  }
}
